export const ALL_SERVICES = [
  "user-auth",
  "client-management",
  "member-management",
  "iqms",
  "project",
  "knowledge",
  "search",
  "notification",
  "skill-matrix",
];

const raw = process.env.REACT_APP_ENABLED_SERVICES;
const enabled = new Set(
  (raw && raw.trim() ? raw : ALL_SERVICES.join(","))
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
);

export const isServiceEnabled = (name) => enabled.has(name);
